<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Doanh số giao dịch MA (TPV)</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          v-show="[2, 3].includes(activeTab)"
        />
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="loadData()">
          <div class="form-group">
            <input
              v-model.trim="filters.merchantInfo"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mcc"
              :options="[{ id: '0', text: 'Tất cả' }, ...dataConfigMcc]"
              placeholder="Ngành nghề"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.managerId"
              :settings="managerSettings"
              placeholder="Tìm kiếm quản lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :settings="staffSettings"
              placeholder="Tìm kiếm nhân viên chăm sóc"
              @change="changeStaff"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.configStaff"
              :options="optionCare"
              placeholder="Loại chăm sóc"
              :disabled="!filters.staffId || filters.staffId === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.merchantType"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionMerchantType]"
              placeholder="Loại Merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeTransaction"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionTransactionType]"
              placeholder="Loại giao dịch cấp 1"
              :disabled="activeTab === 3"
              @change="updateTypeOneTransaction"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.subTypeTransaction1"
              :options="[
                { id: '0', text: 'Tất cả' },
                ...optionSubTypeTransaction1
              ]"
              placeholder="Loại giao dịch cấp 2"
              :disabled="activeTab === 3 || subTypeTransaction1Bool"
              @change="updateTypeTwoTransaction"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.subTypeTransaction2"
              :options="[
                { id: '0', text: 'Tất cả' },
                ...optionSubTypeTransaction2
              ]"
              placeholder="Loại giao dịch cấp 3"
              :disabled="activeTab === 3 || subTypeTransaction2Bool"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeMc"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionTypeMc]"
              placeholder="Nhóm merchant tính KPI"
              :disabled="activeTab === 2"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label
                  v-else
                  style="min-width: 13.5em"
                  class="font-size-12 time-placeholder"
                >
                  Thời gian giao dịch
                </label>
                <i
                  class="bx bx-calendar fonsize-20"
                  style="
                    position: absolute;
                    right: 1px;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                ></i>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.statusMc"
              :options="[{ id: '0', text: 'Tất cả' }, ...listMcStatus]"
              placeholder="Trạng thái hoạt động"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="submit"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click.prevent.stop="clearSearch"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>

      <div class="card-body">
        <div class="tab-content">
          <div class="p-10">
            <div class="container-ma">
              <div
                class="title"
                :class="{ active: activeTab === 1 }"
                @click.prevent.stop="setActiveTab(1)"
              >
                Tổng quan
              </div>
              <div
                class="title"
                :class="{ active: activeTab === 2 }"
                @click.prevent.stop="setActiveTab(2)"
              >
                Danh sách TPV theo loại giao dịch
              </div>
              <div
                class="title"
                :class="{ active: activeTab === 3 }"
                @click.prevent.stop="setActiveTab(3)"
              >
                Danh sách TPV theo nhóm merchant
              </div>
            </div>
          </div>
        </div>
      </div>

      <tpvMaGeneral ref="tpvMaGeneralRef" v-show="activeTab === 1" />
      <tpvMaList
        ref="tpvMaListRef"
        :dataConfigMcc="dataConfigMcc"
        :listMcStatus="listMcStatus"
        :fieldsTable="fieldsTable"
        v-show="[2, 3].includes(activeTab)"
      />
    </div>
  </div>
</template>
<script>
import { CommonService } from '@/services/common.service'
import { StaffService } from '@/services/staff.service'
import Config from '@/thirdParty/config'
import tpvMaGeneral from './components/tpv-ma-general.vue'
import tpvMaList from './components/tpv-ma-list.vue'
import moment from 'moment'

const fieldsTable = [
  { key: 'index', label: 'STT', class: 'text-center' },
  {
    key: 'merchantName',
    label: 'Thông tin Merchant',
    thStyle: 'min-width: 300px'
  },
  { key: 'merchantType', label: 'Loại Merchant', thStyle: 'min-width: 150px' },
  { key: 'sales', label: 'Nhân viên chăm sóc', thStyle: 'min-width: 200px' },
  { key: 'tpv', label: 'TPV', thStyle: 'min-width: 300px' },
  { key: 'tpv', label: 'TPV', thStyle: 'min-width: 300px' },
  { key: 'tpvKpi', label: 'TPV KPI', thStyle: 'min-width: 300px' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]

export default {
  components: { tpvMaGeneral, tpvMaList },
  data() {
    return {
      Config,
      fieldsTable,
      dataConfigMcc: [],
      filters: {},
      listUser: [],
      optionMerchantType: [
        { id: 'MC_KEY', text: 'Merchant key' },
        { id: 'MC_NORMAL', text: 'Merchant thường' }
      ],
      dateRange: {
        startDate: null,
        endDate: null
      },
      userId: JSON.parse(localStorage.getItem('userData')).userId,
      listMcStatus: [],
      optionCare: [
        { id: 'MAIN', text: 'Chăm sóc chính' },
        { id: 'SECOND', text: 'Chăm sóc phụ' }
      ],
      optionTransactionType: [
        { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
        { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
        { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
        { id: 'BNPL', text: 'BNPL' },
        { id: 'MOTO', text: 'Moto' },
        { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
        { id: 'OTHER', text: 'Other' }
      ],
      optionTypeMc: [
        { id: 'NEW_MC', text: 'MC mới' },
        { id: 'OLD_MC_NEW_BRANCH', text: 'MC cũ CN mới' },
        { id: 'OLD_MC_REACTIVATED', text: 'MC cũ kích hoạt lại' },
        { id: 'OTHER', text: 'MC không tính KPI' }
      ],
      activeTab: 1,
      optionSubTypeTransaction1: [],
      optionSubTypeTransaction2: [],
      optionSubType: [
        // 1
        {
          id: 'MANUAL_PAYMENT_BANK',
          text: 'Thanh toán thẻ',
          parent: 'MANUAL_PAYMENT'
        },
        {
          id: 'MANUAL_PAYMENT_NFC',
          text: 'Thanh toán NFC',
          parent: 'MANUAL_PAYMENT'
        },

        { id: 'MANUAL_PAYMENT_QR', text: 'QR code', parent: 'MANUAL_PAYMENT' },

        {
          id: 'ONLINE_PAYMENT_BANK',
          text: 'Thanh toán thẻ',
          parent: 'ONLINE_PAYMENT'
        },
        {
          id: 'ONLINE_PAYMENT_NFC',
          text: 'Thanh toán NFC',
          parent: 'ONLINE_PAYMENT'
        },
        {
          id: 'ONLINE_PAYMENT_QR',
          text: 'Qr code/khác',
          parent: 'ONLINE_PAYMENT'
        },
        {
          id: 'ONLINE_PAYMENT_PAYON',
          text: 'Tích hợp Payon',
          parent: 'ONLINE_PAYMENT'
        },

        // 2
        {
          id: 'MANUAL_PAYMENT_QR_VIETQR',
          text: 'VIETQR',
          parent: 'MANUAL_PAYMENT',
          parent_sub1: 'MANUAL_PAYMENT_QR'
        },
        {
          id: 'MANUAL_PAYMENT_QR_CREDIT',
          text: 'QR thẻ tín dụng',
          parent: 'MANUAL_PAYMENT',
          parent_sub1: 'MANUAL_PAYMENT_QR'
        },
        {
          id: 'MANUAL_PAYMENT_QR_OTHER',
          text: 'QR khác',
          parent: 'MANUAL_PAYMENT',
          parent_sub1: 'MANUAL_PAYMENT_QR'
        },

        {
          id: 'MANUAL_PAYMENT_NFC_AGS',
          text: 'NFC qua AGS',
          parent: 'MANUAL_PAYMENT',
          parent_sub1: 'MANUAL_PAYMENT_NFC'
        },
        {
          id: 'MANUAL_PAYMENT_NFC_BANK',
          text: 'NFC bằng thẻ',
          parent: 'MANUAL_PAYMENT',
          parent_sub1: 'MANUAL_PAYMENT_NFC'
        }
      ],
      subTypeTransaction1Bool: true,
      subTypeTransaction2Bool: true,
      managerOptions: [],
      managerSettings: {
        ajax: {
          delay: 100,
          transport: (params, success) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            success({
              results: this.managerOptions
                .filter((user) => {
                  return (
                    user.text.toLowerCase().indexOf(txtSearch.toLowerCase()) >
                    -1
                  )
                })
                .slice(0, 10)
            })
          }
        }
      },
      staffSettings: {
        ajax: {
          delay: 100,
          transport: (params, success) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            success({
              results: this.listUser
                .filter((user) => {
                  return (
                    user.text.toLowerCase().indexOf(txtSearch.toLowerCase()) >
                    -1
                  )
                })
                .slice(0, 10)
            })
          }
        }
      }
    }
  },
  created() {
    // set init value
  },

  async mounted() {
    await this.configSystem()
    await this.getManager()
    await this.getListStaffBySuperior()
    await this.loadData()
  },

  methods: {
    buildFilter() {
      const filtersRequest = {}
      if (this.dateRange.endDate) {
        filtersRequest.dateTransactionTo = moment(
          this.dateRange.endDate
        ).format('YYYY-MM-DD')
      }
      if (this.dateRange.startDate) {
        filtersRequest.dateTransactionFrom = moment(
          this.dateRange.startDate
        ).format('YYYY-MM-DD')
      }
      for (const key in this.filters) {
        const value = this.filters[key]
        if (value !== '0') filtersRequest[key] = value
      }
      return filtersRequest
    },
    async loadData() {
      const filterData = this.buildFilter()
      switch (this.activeTab) {
        case 1:
          this.$refs.tpvMaGeneralRef.loadData(filterData)
          break
        case 2:
          filterData.showTpvType = 'TRANSACTION_TYPE'
          this.$refs.tpvMaListRef.loadData(filterData)
          break
        case 3:
          filterData.showTpvType = 'MC_GROUP'
          this.$refs.tpvMaListRef.loadData(filterData)
          break
      }
    },
    async configSystem() {
      return CommonService.getConfigSystem()
        .then((data) => {
          if (data.success) {
            this.dataConfigMcc = data.data.businessFields.map((e) => {
              return {
                id: e.code,
                text: e.name
              }
            })
            this.listMcStatus = data.data.merchantAccountStatus.map((e) => {
              return {
                ...e,
                id: e.code,
                text: e.name
              }
            })
          }
        })
        .catch((error) => this.showFailMx(error.message ?? error))
    },
    async getManager() {
      try {
        const data = await StaffService.superiors()
        if (data.success) {
          this.managerOptions = data.data.map((e) => {
            return {
              id: e.id,
              text: `${e.name} - ${e.userName}`
            }
          })
          this.managerOptions.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getListStaffBySuperior() {
      try {
        const data = await StaffService.getStaffByIdSuperior({
          userId: this.userId
        })
        if (data.data.length > 0) {
          this.listUser = data.data.map((e) => {
            return {
              id: e.userId,
              text: `${e.name} - ${e.userName}`
            }
          })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    clearSearch() {
      this.filters = {}
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.optionSubTypeTransaction1 = []
      this.optionSubTypeTransaction2 = []
      this.subTypeTransaction1Bool = true
      this.subTypeTransaction2Bool = true

      this.loadData()
    },

    setActiveTab(tab) {
      if (this.activeTab === tab) return
      this.activeTab = tab
      switch (tab) {
        case 1:
          delete this.filters.showTpvType
          break
        case 2:
          this.filters.showTpvType = 'TRANSACTION_TYPE'
          delete this.filters.typeMc
          break
        case 3:
          this.filters.showTpvType = 'MC_GROUP'
          delete this.filters.typeTransaction
          delete this.filters.subTypeTransaction1
          delete this.filters.subTypeTransaction2
          break
      }
      this.loadData()
    },

    changeStaff() {
      this.filters.configStaff = 'MAIN'
      if (!this.filters.staffId || this.filters.staffId === '0')
        delete this.filters.configStaff
    },
    updateTypeOneTransaction() {
      this.subTypeTransaction2Bool = true
      this.subTypeTransaction1Bool = true
      this.filters.subTypeTransaction1 = ''
      this.filters.subTypeTransaction2 = ''

      if (
        !this.filters.typeTransaction ||
        this.filters.typeTransaction === '0'
      ) {
        this.filters.subTypeTransaction2 = ''
        this.subTypeTransaction1Bool = true
        this.optionSubTypeTransaction1 = []
        this.optionSubTypeTransaction2 = []
      }
      if (this.filters.typeTransaction === 'ONLINE_PAYMENT') {
        this.subTypeTransaction1Bool = false
        this.optionSubTypeTransaction1 = this.optionSubType.filter(
          (s) => s.parent === 'ONLINE_PAYMENT'
        )
      }
      if (this.filters.typeTransaction === 'MANUAL_PAYMENT') {
        this.subTypeTransaction1Bool = false
        this.optionSubTypeTransaction1 = this.optionSubType.filter(
          (s) => s.parent === 'MANUAL_PAYMENT' && !s.parent_sub1
        )
      }
    },
    updateTypeTwoTransaction() {
      this.subTypeTransaction2Bool = true
      this.filters.subTypeTransaction2 = ''
      this.subTypeTransaction1Bool = false

      if (this.filters.subTypeTransaction1 === 'MANUAL_PAYMENT_QR') {
        this.subTypeTransaction2Bool = false
        this.optionSubTypeTransaction2 = this.optionSubType.filter(
          (s) => s.parent_sub1 === 'MANUAL_PAYMENT_QR'
        )
      } else if (this.filters.subTypeTransaction1 === 'MANUAL_PAYMENT_NFC') {
        this.subTypeTransaction2Bool = false
        this.optionSubTypeTransaction2 = this.optionSubType.filter(
          (s) => s.parent_sub1 === 'MANUAL_PAYMENT_NFC'
        )
      } else {
        this.optionSubTypeTransaction2 = []
      }
    }
  }
}
</script>

<style scoped>
.container-ma {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
}

.title {
  font-size: 16px;
  color: gray;
  cursor: pointer;
}

.active {
  font-size: 16px;
  color: #007bff;
  position: relative;
}

.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #007bff;
  position: absolute;
  bottom: -5px;
  left: 0;
}
</style>
